import React, { useContext, useEffect, useRef, useState } from "react";
import {
  FaBox,
  FaToggleOff,
  FaToggleOn,
  FaCheckDouble,
  FaEye,
  FaEyeSlash,
} from "react-icons/fa";
import { AiOutlineAppstore, AiOutlineTag } from "react-icons/ai";
import { AiOutlineFullscreen } from "react-icons/ai";
import { SlNotebook } from "react-icons/sl";
import logo from "../assest/logo.png";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { storeLogout } from "../store/slices/storeSlice";
import { CiMenuKebab, CiMenuBurger } from "react-icons/ci";
import { setToggleTheme } from "../store/slices/themeSlice";
import LangaugeSelector from "./languageSelector/LangaugeSelector";
import Tooltip from "./Tooltip/Tooltip";
import { useSocket } from "./Socket/SocketProvider";
import moment from "moment/moment";
import {
  MdNotifications,
  MdNotificationsActive,
  MdOutlineMarkChatRead,
} from "react-icons/md";
import { TbBellRinging } from "react-icons/tb";
import LoaderContext from "./loader";
import masterApi from "../apis/master.api";
import { getToken } from "firebase/messaging";
import { messaging } from "../firebase";
import { NotificationApi } from "../apis/Notification.apis";

const Topbar = ({ handleSidebar }) => {
  const { handleLoading } = useContext(LoaderContext);
  const { currentUser } = useSelector((state) => state.store);
  const [ApprovalStatus, setApprovalStatus] = useState(false);
  const notificationRef = useRef(null);
  const [isNotification, setIsNotification] = useState(true);
  const [notificationData, setNotificationData] = useState([]);
  const [filteredNotifications, setFilteredNotifications] = useState([]);
  const [newNotiCount, setNewNotiCount] = useState(0);
  const [notification, setNotification] = useState(false);
  const [filter, setFilter] = useState("all");
  const navigate = useNavigate();

  const userName = currentUser && currentUser?.first_name;
  const profileRef = useRef(null);
  const menuRef = useRef(null);
  const dispatch = useDispatch();
  const { theme } = useSelector((state) => state.theme);
  const [showProfile, setShowProfile] = useState(false);
  const [showMenu, setShowMenu] = useState(false);

  const getAllNotification = async () => {
    try {
      const res = await masterApi.getAllNotifications();
      console.log("getAllNotifications:", res.data.data.allNotifications);
      const { allNotifications, unreadCount } = res.data.data;
      setNotificationData(allNotifications);
      setNewNotiCount(unreadCount);
    } catch (err) {
      console.error(err);
    }
  };
  console.log("all-notifications:", notificationData);
  console.log("newNotiCount:", newNotiCount);

  const requestPermission = async (userId) => {
    try {
      const registration = await navigator.serviceWorker.register(
        "/firebase-messaging-sw.js"
      );
      console.log("Service Worker registered successfully:", registration);

      const token = await getToken(messaging, {
        vapidKey:
          "BMo02YcnmQse0hSsElAGS5uhoCqqklji5twX8Yv9YK8mGZab3BK68wnkFso0Re6Rfl8uzuLiFYc0sfmIfLkPJWk",
      });

      if (token) {
        console.log("Token received:", token);

        const payload = {
          user_id: userId || null,
          fcm_token: token,
          device_type: "web",
        };

        (async () => {
          try {
            handleLoading(true);
            const res = await masterApi.saveFcmToken(payload);
            console.log("This is the response of the fcm token ", res.data);
          } catch (err) {
            console.log(err);
          } finally {
            handleLoading(false);
          }
        })();
      } else {
        console.log(
          "No registration token available. Request permission to generate one."
        );
      }
    } catch (error) {
      console.error("Error getting token:", error);
    }
  };

  useEffect(() => {
    // setNotificationData(mockNotifications);
    getAllNotification();
    // const unreadCount = mockNotifications.filter(noti => !noti.is_read).length;
    // setNewNotiCount(unreadCount);
  }, []);

  // Filter notifications based on selected filter
  useEffect(() => {
    if (filter === "all") {
      setFilteredNotifications(notificationData);
    } else if (filter === "unread") {
      setFilteredNotifications(
        notificationData.filter((noti) => !noti.is_read)
      );
    } else if (filter === "read") {
      setFilteredNotifications(notificationData.filter((noti) => noti.is_read));
    }
  }, [filter, notificationData]);

  // Mock API function to mark notification as read
 const markAsRead = async (id) => {
  console.log("markAsRead id:",id)
  try {
    // ✅ call backend single read
    await masterApi.markSingleRead(id);

    // ✅ update local state based on previous state (no stale data)
    setNotificationData((prev) => {
      const updated = prev.map((noti) =>
        noti.id === id ? { ...noti, is_read: true } : noti
      );

      // ✅ set count from updated array
      const unreadCount = updated.filter((n) => !n.is_read).length;
      setNewNotiCount(unreadCount);

      return updated;
    });
  } catch (err) {
    console.error(err);
  }
  finally {
    getAllNotification();
    navigate("store/order/all-orders");
  }
};


  // Mock API function to mark all as read
  const markAllAsRead = async () => {
  try {
    await masterApi.markAllRead();

    setNotificationData((prev) => {
      const updated = prev.map((noti) => ({ ...noti, is_read: true }));
      setNewNotiCount(0);
      return updated;
    });
  } catch (err) {
    console.error(err);
  }
  finally {
    
    getAllNotification();
  }
};


  // Handle notification click
  const handleNotificationClick = (noti) => {
    if (!noti.is_read) {
      console.log("handleNotificationClick noti:",noti)
      markAsRead(noti._id);
    }
    // Handle navigation based on notification type
    switch (noti.type) {
      case "order":
        navigate("order/all-orders");
        break;
      case "promotion":
        navigate("offers/promocode");
        break;
      case "report":
        navigate("earning/current-week");
        break;
      default:
        break;
    }
  };

  // Handle clear all notifications
  const handleClearAll = () => {
    setNotificationData([]);
    setNewNotiCount(0);
    // In real app: API call here
    // await api.clearAllNotifications();
  };

  function toggleFullScreen() {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      }
    }
  }


  const getNotification = async (id) => {
    console.log("notification id:",id);
    
    const payload = {
      is_read: true,
    };
    try {
      const res = id
        ? await NotificationApi.updateNotification(id,payload)
        : await NotificationApi.getAllNotification();
      const newNotifications = res.data.data.allNotifications;
      const newCount = newNotifications.filter(
        (newNoti) =>
          !notificationData.some((oldNoti) => oldNoti.id === newNoti.id) &&
          !newNoti.is_read
      ).length;

      setNotificationData(newNotifications);
      setNewNotiCount(newCount);
      console.log("notification data:", newNotifications);
      console.log("new notification Count:", newCount);
    } catch (err) {
      console.error("error:", err);
    }
  };


const handleNotiBoxClick = (noti) => {
    navigate(`/store/order/all-orders`);
    console.log("noti:", noti);

    setNewNotiCount(null);
    getNotification(noti._id);
  };

  useEffect(() => {
    getNotification();

    const interval = setInterval(() => {
      getNotification();
    }, 30000);

    return () => clearInterval(interval);
  }, []);







  useEffect(() => {
    setApprovalStatus(
      !(currentUser?.status === "Pending" || currentUser?.status === "Pending")
    );
  }, [currentUser?.status]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        notificationRef.current &&
        !notificationRef.current.contains(event.target)
      ) {
        setNotification(false);
      }
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setShowProfile(false);
      }
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleDark = () => {
    dispatch(setToggleTheme("dark"));
  };

  const handleLight = () => {
    dispatch(setToggleTheme("light"));
  };

  return (
    <div
      className={`${
        theme === "light"
          ? "bg-secondaryColor text-primaryColor"
          : "bg-darkThirsary text-darkSecondary"
      } shadow-md h-16 w-full flex items-center justify-between px-5 py-12 fixed z-20`}
    >
      <div className="flex gap-7">
        <span
          className="cursor-pointer flex  justify-between items-center"
          onClick={handleSidebar}
        >
          <CiMenuKebab className="font-black" />
          <CiMenuBurger className="font-black" />
        </span>
        {/* <LangaugeSelector /> */}
      </div>

      <div>
        <img src={logo} alt="Logo" width={175} />
      </div>

      <div className="flex gap-3 text-xl items-center">
        {!ApprovalStatus ? (
          <span className=" flex justify-center items-center cursor-pointer text-hoverColor hover:text-hoverColor">
            <i> Your Account is unapproved</i>
            <Tooltip
              position="bottom"
              text={
                <>
                  <li>Upload Documents</li>
                  <li>Update Bank details</li>
                </>
              }
            />
          </span>
        ) : (
          ""
        )}

        {/* Enhanced Notifications */}
        <div className="relative text-gray-700" ref={notificationRef}>
          <div
            className="cursor-pointer relative inline-block"
            onClick={() => {
              getAllNotification();
              setNotification(!notification);
              setIsNotification(!isNotification);
            }}
          >
            {newNotiCount > 0 && (
              <div className="absolute -top-2 -right-2 bg-red500 text-white text-xs font-bold w-10 h-5 flex items-center justify-center rounded-full z-50">
                {newNotiCount}
              </div>
            )}

            {isNotification ? (
              <MdNotifications className="text-2xl hover:text-hoverColor" />
            ) : (
              <MdNotificationsActive className="text-2xl text-blue500 shake" />
            )}
          </div>

          {notification && (
            <div
              className={`absolute top-12 right-0 w-96 ${
                theme === "light"
                  ? "bg-white border-gray-200"
                  : "bg-gray900 border-gray-700"
              } shadow-xl border rounded-lg transform transition-all duration-300`}
              style={{ maxHeight: "70vh" }}
            >
              {/* Header */}
              <div
                className={`px-4 py-3 border-b ${
                  theme === "light" ? "border-gray-200" : "border-gray-700"
                } flex justify-between items-center`}
              >
                <div className="flex items-center gap-2">
                  <p
                    className={`font-bold text-lg ${
                      theme === "light" ? "text-gray-800" : "text-white"
                    }`}
                  >
                    Notifications
                  </p>
                  {newNotiCount > 0 && (
                    <span className="bg-red-500 text-white text-xs px-2 py-0.5 rounded-full">
                      {newNotiCount} new
                    </span>
                  )}
                </div>
                <div className="flex gap-2">
                  {newNotiCount > 0 && (
                    <button
                      onClick={markAllAsRead}
                      className={`flex items-center gap-1 px-2 py-1 text-xs rounded ${
                        theme === "light"
                          ? "bg-blue-50 text-blue-600 hover:bg-blue-100"
                          : "bg-blue-900/30 text-blue-300 hover:bg-blue-900/50"
                      } transition-colors`}
                      title="Mark all as read"
                    >
                      <FaCheckDouble /> Mark all as read
                    </button>
                  )}
                  {/* {notificationData.length > 0 && (
                    <button
                      onClick={handleClearAll}
                      className={`px-2 py-1 text-xs rounded ${theme === "light"
                          ? "text-gray-500 hover:text-gray-700 hover:bg-gray-100"
                          : "text-gray-400 hover:text-gray-200 hover:bg-gray-800"
                        } transition-colors`}
                      title="Clear all notifications"
                    >
                      Clear
                    </button>
                  )} */}
                </div>
              </div>

              {/* Filter Tabs */}
              <div
                className={`flex border-b ${
                  theme === "light" ? "border-gray-200" : "border-gray-700"
                }`}
              >
                {["all", "unread", "read"].map((tab) => (
                  <button
                    key={tab}
                    onClick={() => setFilter(tab)}
                    className={`flex-1 py-2 text-sm font-medium capitalize ${
                      filter === tab
                        ? theme === "light"
                          ? "text-blue-600 border-b-2 border-blue-600"
                          : "text-blue-400 border-b-2 border-blue-400"
                        : theme === "light"
                        ? "text-gray-500 hover:text-gray-700"
                        : "text-gray-400 hover:text-gray-200"
                    } transition-colors`}
                  >
                    {tab}{" "}
                    {tab === "unread" &&
                      newNotiCount > 0 &&
                      `(${newNotiCount})`}
                  </button>
                ))}
              </div>

              {/* Notifications List */}
              <div
                className="overflow-y-auto"
                style={{ maxHeight: "calc(50vh - 120px)" }}
              >
                {filteredNotifications?.length > 0 ? (
                  filteredNotifications?.map((noti) => (
                    <div
                      key={noti.id}
                      className={`flex items-start gap-2 p-2 cursor-pointer transition-all duration-200 ${
                        noti.is_read
                          ? theme === "light"
                            ? "hover:bg-gray-50"
                            : "hover:bg-gray-800"
                          : theme === "light"
                          ? "bg-blue-50 hover:bg-blue-100"
                          : "bg-blue-900/20 hover:bg-blue-900/30"
                      } border-b ${
                        theme === "light"
                          ? "border-gray-100"
                          : "border-gray-800"
                      }`}
                      onClick={() => handleNotificationClick(noti)}
                    >
                      {/* Icon */}
                      <div
                        className={`p-2 rounded-full  ${
                          noti.is_read
                            ? theme === "light"
                              ? "bg-gray-100"
                              : "bg-gray-800"
                            : theme === "light"
                            ? "bg-blue-100"
                            : "bg-blue-900"
                        }`}
                      >
                        {noti.icon}
                      </div>

                      {/* Content */}
                      <div className="flex-1 min-w-0">
                        <div className="flex justify-between items-start mb-1">
                          <p
                            className={`font-medium text-sm ${
                              theme === "light" ? "text-gray-900" : "text-white"
                            } ${!noti.is_read ? "font-semibold" : ""}`}
                          >
                            {noti.title}
                          </p>
                          <div className="flex items-center gap-2">
                            <span
                              className={`text-xs ${
                                theme === "light"
                                  ? "text-gray-500"
                                  : "text-gray-400"
                              }`}
                            >
                              {moment(noti.createdAt).fromNow()}
                            </span>
                            {/* {!noti.is_read && (
                              <span className="w-2 h-2 bg-blue-500 rounded-full animate-pulse"></span>
                            )} */}
                          </div>
                        </div>
                        <p
                          className={`text-sm truncate ${
                            theme === "light"
                              ? "text-gray-600"
                              : "text-gray-300"
                          }`}
                        >
                          {noti.message}
                        </p>
                      </div>

                      {/* Action Button */}
                      {!noti.is_read && (
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            markAsRead(noti._id);
                          }}
                          className={`ml-2  rounded ${
                            theme === "light"
                              ? "text-blue-600 hover:bg-blue-100"
                              : "text-blue-400 hover:bg-blue-900/30"
                          } transition-colors`}
                          title="Mark as read"
                        >
                          <FaEyeSlash size={14} />
                        </button>
                      )}
                    </div>
                  ))
                ) : (
                  <div className="flex flex-col items-center justify-center py-10 px-4">
                    <div
                      className={`p-4 rounded-full mb-3 ${
                        theme === "light" ? "bg-gray-100" : "bg-gray-800"
                      }`}
                    >
                      <TbBellRinging
                        size={32}
                        className={
                          theme === "light" ? "text-gray-400" : "text-gray-500"
                        }
                      />
                    </div>
                    <p
                      className={`font-medium ${
                        theme === "light" ? "text-gray-700" : "text-gray-300"
                      } mb-1`}
                    >
                      No notifications
                    </p>
                    <p
                      className={`text-sm ${
                        theme === "light" ? "text-gray-500" : "text-gray-400"
                      } text-center`}
                    >
                      {filter === "all"
                        ? "You're all caught up!"
                        : `No ${filter} notifications`}
                    </p>
                  </div>
                )}
              </div>

              {/* Footer */}
              {notificationData?.length > 0 && (
                <div
                  className={`px-4 py-3 border-t ${
                    theme === "light"
                      ? "border-gray-200 bg-gray-50"
                      : "border-gray-700 bg-gray-900"
                  }`}
                >
                  <div className="flex justify-between items-center text-sm">
                    <span
                      className={
                        theme === "light" ? "text-gray-600" : "text-gray-400"
                      }
                    >
                      {filteredNotifications.length} of{" "}
                      {notificationData.length}
                    </span>
                    <button
                      onClick={() => {
                        setNotification(false); // close dropdown
                        navigate("notifications");
                      }}
                      className={`hover:underline ${
                        theme === "light" ? "text-blue-600" : "text-blue-400"
                      }`}
                    >
                      View all
                    </button>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>

        {/* Rest of your existing code... */}
        <div className="hidden md:flex gap-3 text-xl items-center">
          {theme === "light" ? (
            <FaToggleOff
              className="cursor-pointer hover:text-hoverColor text-3xl"
              onClick={handleDark}
            />
          ) : (
            <FaToggleOn
              className="cursor-pointer hover:text-hoverColor text-3xl"
              onClick={handleLight}
            />
          )}
          {ApprovalStatus ? (
            <div onClick={() => setShowMenu(!showMenu)}>
              <AiOutlineAppstore className="cursor-pointer relative hover:text-hoverColor" />
              {showMenu ? <MenuDD ref={menuRef} /> : null}
            </div>
          ) : (
            ""
          )}
          <AiOutlineFullscreen
            className="cursor-pointer hover:text-hoverColor"
            onClick={toggleFullScreen}
          />
        </div>
        <div
          className="flex items-center gap-2 cursor-pointer hover:text-hoverColor "
          onClick={() => setShowProfile(!showProfile)}
        >
          <span className="text-sm text-bluefont hidden md:flex capitalize ">
            {userName}
          </span>
          <div className="relative ">
            <img
              src={logo}
              alt="Logo"
              width={40}
              className=" rounded-full border "
            />
            {showProfile ? (
              <ProfileDD ApprovalStatus={ApprovalStatus} ref={profileRef} />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Topbar;

const ProfileDD = React.forwardRef((props, ref) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { socket } = useSocket();

  const { theme } = useSelector((state) => state.theme);
  const handleLogout = async () => {
    const payload = { payload: null, token: false };
    dispatch(storeLogout(payload));
    socket.off();
    socket.disconnect();
  };
  return (
    <div
      ref={ref}
      className={` ${
        theme === "light"
          ? "bg-secondaryColor text-primaryColor"
          : "bg-darkPrimary text-darkSecondary"
      } border absolute right-0 shadow-sm mt-2 rounded-lg text-sm w-44`}
    >
      {props.ApprovalStatus ? (
        <ul>
          <li
            className={`cursor-pointer py-2 px-4 ${
              theme === "light"
                ? "hover:bg-[#f8f8f8]"
                : "hover:bg-thirsaryColor"
            }`}
            onClick={() => navigate("profile")}
          >
            Account
          </li>
          <li
            className={`cursor-pointer py-2 px-4 ${
              theme === "light"
                ? "hover:bg-[#f8f8f8]"
                : "hover:bg-thirsaryColor"
            }`}
            onClick={() => navigate("offers/promocode")}
          >
            Offers
          </li>
          <li
            className={`cursor-pointer py-2 px-4 ${
              theme === "light"
                ? "hover:bg-[#f8f8f8]"
                : "hover:bg-thirsaryColor"
            }`}
            onClick={() => navigate("order/delivered-orders")}
          >
            History
          </li>
        </ul>
      ) : (
        ""
      )}
      <div
        className={`border-t cursor-pointer py-2 px-4 ${
          theme === "light" ? "hover:bg-[#f8f8f8]" : "hover:bg-thirsaryColor"
        }`}
        onClick={handleLogout}
      >
        Sign Out
      </div>
    </div>
  );
});

const MenuDD = React.forwardRef((props, ref) => {
  const { theme } = useSelector((state) => state.theme);
  const navigate = useNavigate();
  return (
    <div
      ref={ref}
      className={`${
        theme === "light"
          ? "bg-secondaryColor text-primaryColor"
          : "bg-darkPrimary text-darkSecondary"
      } border top-10 mt-5 right-40 mr-10  absolute  shadow-sm  rounded-lg text-sm w-fit `}
    >
      <div className="flex">
        <div
          className="lg:flex hidden   py-4 px-6 gap-2 items-center border-b  border-slate-100 flex-col cursor-pointer  hover:text-hoverColor hover:font-semibold"
          onClick={() => navigate("order/all-orders")}
        >
          <p className="text-3xl">
            <SlNotebook />
          </p>
          <p className="text-[12px]">Order</p>
        </div>
        {/* <div
          className="lg:flex hidden   py-4 px-6 gap-2  items-center border-b  border-slate-100 flex-col cursor-pointer text-secondaryfont hover:text-hoverColor hover:font-semibold"
          onClick={() => navigate("earning/current-week")}
        >
          <p className="text-3xl">
            <GiCoins />
          </p>
          <p className="text-[12px] ">Earning</p>
        </div> */}
        <div
          className="lg:flex hidden   py-4 px-6 gap-2  items-center border-b  border-slate-100 flex-col cursor-pointer text-secondaryfont hover:text-hoverColor hover:font-semibold"
          onClick={() => navigate("offers/promocode")}
        >
          <p className="text-3xl">
            <AiOutlineTag />
          </p>
          <p className="text-[12px] ">Offers</p>
        </div>
      </div>
      <div className="flex">
        <div
          className="lg:flex hidden   py-4 px-6 gap-2  items-center border-b  border-slate-100 flex-col cursor-pointer text-secondaryfont hover:text-hoverColor hover:font-semibold"
          onClick={() => navigate("menu/item-list")}
        >
          <p className="text-3xl">
            <SlNotebook />
          </p>
          <p className="text-[12px] ">Menu</p>
        </div>
      </div>
    </div>
  );
});

// I am currently changed the notification system to a mock system for demonstration purposes.And this code in below is the previous version of Topbar.jsx before enhancement of notification system.
// import React, { useEffect, useRef, useState } from "react";
// import { FaBox, FaToggleOff, FaToggleOn } from "react-icons/fa";
// import { AiOutlineAppstore, AiOutlineTag } from "react-icons/ai";
// import { AiOutlineFullscreen } from "react-icons/ai";
// import { SlNotebook } from "react-icons/sl";
// import { CiSettings } from "react-icons/ci";
// import logo from "../assest/logo.png";
// import { useNavigate } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import { storeLogout } from "../store/slices/storeSlice";
// import { CiMenuKebab } from "react-icons/ci";
// import { CiMenuBurger } from "react-icons/ci";
// import { setToggleTheme } from "../store/slices/themeSlice";
// import LangaugeSelector from "./languageSelector/LangaugeSelector";
// import Tooltip from "./Tooltip/Tooltip";
// import { useSocket } from "./Socket/SocketProvider";
// import moment from "moment/moment";
// import { MdNotifications, MdNotificationsActive } from "react-icons/md";

// const Topbar = ({ handleSidebar }) => {
//   const { currentUser } = useSelector((state) => state.store);
//   const [ApprovalStatus, setApprovalStatus] = useState(false);
//   const notificationRef = useRef(null);
//   const [isNotification, setIsNotification] = useState(true);
//   const [notificationData, setNotificationData] = useState([]);
//   const [newNotiCount, setNewNotiCount] = useState(null);
//   const [notification, setNotification] = useState(false);

//   const userName = currentUser && currentUser?.first_name;

//   const profileRef = useRef(null);
//   const menuRef = useRef(null);

//   const dispatch = useDispatch();

//   const { theme } = useSelector((state) => state.theme);

//   const [showProfile, setShowProfile] = useState(false);
//   const [showMenu, setShowMenu] = useState(false);

//   function toggleFullScreen() {
//     if (!document.fullscreenElement) {
//       document.documentElement.requestFullscreen();
//     } else {
//       if (document.exitFullscreen) {
//         document.exitFullscreen();
//       }
//     }
//   }

//   useEffect(() => {
//     console.log("currentUser?.status", currentUser?.status);
//     console.log(
//       "currentUser?.status",
//       !(
//         currentUser?.status === "Pending" ||
//         currentUser?.status === "Pending"
//       )
//     );

//     setApprovalStatus(
//       !(
//         currentUser?.status === "Pending" ||
//         currentUser?.status === "Pending"
//       )
//     );
//   }, [currentUser?.status]);

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (profileRef.current && !profileRef.current.contains(event.target)) {
//         setShowProfile(false);
//       }
//       if (menuRef.current && !menuRef.current.contains(event.target)) {
//         setShowMenu(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   const handleDark = () => {
//     dispatch(setToggleTheme("dark"));
//   };

//   const handleLight = () => {
//     dispatch(setToggleTheme("light"));
//   };

//   return (
//     <div
//       className={`${theme === "light"
//           ? "bg-secondaryColor text-primaryColor"
//           : "bg-darkThirsary text-darkSecondary"
//         } shadow-md h-16 w-full flex items-center justify-between px-5 py-12 fixed z-20`}
//     >
//       <div className="flex gap-7">
//         <span
//           className="cursor-pointer flex  justify-between items-center"
//           onClick={handleSidebar}
//         >
//           <CiMenuKebab className="font-black" />
//           <CiMenuBurger className="font-black" />
//         </span>

//         <LangaugeSelector />
//       </div>

//       <div>
//         <img src={logo} alt="Logo" width={175} />
//       </div>
//       <div className="flex gap-3 text-xl items-center">
//         {!ApprovalStatus ? (
//           <span className=" flex justify-center items-center cursor-pointer text-hoverColor hover:text-hoverColor">
//             <i> Your Account is unapproved</i>
//             <Tooltip
//               position="bottom"
//               text={
//                 <>
//                   <li>Upload Documents</li>
//                   <li>Update Bank details</li>
//                 </>
//               }
//             />
//           </span>
//         ) : (
//           ""
//         )}
//         {/* Notifications */}
//         <div
//           className="relative text-gray-700"
//           onClick={() => {
//             setNotification(!notification);
//             setIsNotification(!isNotification);
//           }}
//         >
//           {isNotification ? (
//             <MdNotifications className="text-2xl hover:text-hoverColor" />
//           ) : (
//             <div className="relative inline-block">
//               {newNotiCount > 0 && (
//                 <p className="absolute -top-2 -right-2 bg-RedColor text-white text-xs font-bold px-2 py-0.5 rounded-full">
//                   {newNotiCount}
//                 </p>
//               )}
//               <MdNotificationsActive className="text-2xl shake" />

//             </div>
//           )}

//           {notification && (
//             <div
//               className={`absolute top-12 right-0 w-[20rem] ${theme === "light" ? "bg-white" : "bg-[#030712]"
//                 }  shadow-lg border rounded-lg`}
//               ref={notificationRef}
//             >
//               <div className="px-4 py-3 border-b">
//                 <p
//                   className={`font-semibold text-lg ${theme === "light" ? "text-[#4A5568]" : "text-[#9CA3AF]"
//                     } text-gray-400`}
//                 >
//                   Notifications
//                 </p>
//               </div>
//               <div className="w-full max-h-[20vh] overflow-y-auto ">
//                 {notificationData && notificationData.length > 0 ? (
//                   notificationData.map((noti, i) => {
//                     return (
//                       <div
//                         className={`${noti.is_read
//                             ? theme === "light"
//                               ? " text-black hover:bg-[#878d99]"
//                               : "bg-[#222324] text-white hover:bg-[#36383a]"
//                             : theme === "light"
//                               ? "bg-[#c6ccd8] text-[#2D3748] hover:bg-[#7a7d81] hover:text-[#c6ccd8] "
//                               : "bg-[#474a53] text-[#E2E8F0] hover:bg-[#282b30] hover:text-[#f0f0f1] "
//                           } border-b cursor-pointer flex items-center w-full p-2`}
//                       // onClick={() => handleNotiBoxClick(noti)}
//                       >
//                         <div className="mr-2 border bg-[#E2E8F0] p-2 rounded-full">
//                           <FaBox size="16px" />
//                         </div>
//                         <div>
//                           <div className="flex justify-between mb-0">
//                             <p className="text-sm line-clamp-2 flex justify-between items-center ">
//                               {noti?.title}
//                             </p>
//                             <p className="text-[14px] line-clamp-1 ">
//                               {moment(noti?.createdAt).utc().format("hh:mma")}
//                             </p>
//                           </div>
//                           <p className="text-[14px] line-clamp-1 mt-0">
//                             {noti?.message}
//                           </p>
//                         </div>
//                       </div>
//                     );
//                   })
//                 ) : (
//                   // <p
//                   //   className={`text-sm italic text-center ${
//                   //     theme === "light" ? "text-[#4A5568]" : "text-gray-400"
//                   //   } text-gray-400`}
//                   // >
//                   //   Notifications are available.
//                   // </p>
//                   <p
//                     className={`text-sm italic text-center ${theme === "light" ? "text-[#4A5568]" : "text-[#9CA3AF]"
//                       } `}
//                   >
//                     Notifications are currently unavailable.
//                   </p>
//                 )}
//               </div>
//               <div className="px-4 py-3 border-t">
//                 {/* <button className="text-primary text-sm">
//                   View all notifications
//                 </button> */}
//               </div>
//             </div>
//           )}
//         </div>

//         <div className="hidden md:flex gap-3 text-xl items-center">
//           {theme === "light" ? (
//             <FaToggleOff
//               className="cursor-pointer hover:text-hoverColor text-3xl"
//               onClick={handleDark}
//             />
//           ) : (
//             <FaToggleOn
//               className="cursor-pointer hover:text-hoverColor text-3xl"
//               onClick={handleLight}
//             />
//           )}
//           {ApprovalStatus ? (
//             <div onClick={() => setShowMenu(!showMenu)}>
//               <AiOutlineAppstore className="cursor-pointer relative hover:text-hoverColor" />
//               {showMenu ? <MenuDD ref={menuRef} /> : null}
//             </div>
//           ) : (
//             ""
//           )}
//           <AiOutlineFullscreen
//             className="cursor-pointer hover:text-hoverColor"
//             onClick={toggleFullScreen}
//           />
//         </div>
//         <div
//           className="flex items-center gap-2 cursor-pointer hover:text-hoverColor "
//           onClick={() => setShowProfile(!showProfile)}
//         >
//           <span className="text-sm text-bluefont hidden md:flex capitalize ">
//             {userName}
//           </span>
//           <div className="relative ">
//             <img
//               src={logo}
//               alt="Logo"
//               width={40}
//               className=" rounded-full border "
//             />
//             {showProfile ? (
//               <ProfileDD ApprovalStatus={ApprovalStatus} ref={profileRef} />
//             ) : null}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Topbar;
